import SkeletonBase from '@/components/skeletonBase';
import '../style.css';

const PatientRequestDetailsSkeleton = () => {
    return (
        <div className="patient-request-details-container">
            {/* Header Skeleton */}
            <div className="patient-request-details-header">
                <div className="patient-request-details-header-left">
                    <SkeletonBase 
                        variant="rounded" 
                        width="100px" 
                        height="40px" 
                        style={{ borderRadius: '8px' }}
                    />
                    <div className="patient-request-details-title-section">
                        <SkeletonBase 
                            variant="text" 
                            width="280px" 
                            height="28px" 
                            style={{ marginBottom: '8px' }}
                        />
                        <SkeletonBase 
                            variant="text" 
                            width="320px" 
                            height="16px" 
                        />
                    </div>
                </div>
                <div className="patient-request-details-header-right">
                    <SkeletonBase 
                        variant="rounded" 
                        width="150px" 
                        height="40px" 
                        style={{ borderRadius: '8px' }}
                    />
                    <SkeletonBase 
                        variant="rounded" 
                        width="130px" 
                        height="40px" 
                        style={{ borderRadius: '8px' }}
                    />
                </div>
            </div>

            <div className="patient-request-details-content">
                {/* Header Info Skeleton */}
                <div className="patient-header-info-section">
                    {[1, 2, 3].map((index) => (
                        <div key={index} className="patient-header-info-item">
                            <SkeletonBase 
                                variant="text" 
                                width="60px" 
                                height="12px" 
                                style={{ marginBottom: '8px' }}
                            />
                            <SkeletonBase 
                                variant="text" 
                                width="120px" 
                                height="20px" 
                            />
                        </div>
                    ))}
                </div>

                {/* Request Overview Skeleton */}
                <div className="patient-request-overview-section">
                    {[1, 2, 3, 4].map((index) => (
                        <div key={index} className="patient-request-overview-item">
                            <SkeletonBase 
                                variant="rounded" 
                                width="40px" 
                                height="40px" 
                                style={{ borderRadius: '8px' }}
                            />
                            <div style={{ flex: 1 }}>
                                <SkeletonBase 
                                    variant="text" 
                                    width="80px" 
                                    height="12px" 
                                    style={{ marginBottom: '6px' }}
                                />
                                <SkeletonBase 
                                    variant="text" 
                                    width="100%" 
                                    height="16px" 
                                />
                            </div>
                        </div>
                    ))}
                </div>

                {/* Medical Diagnosis Skeleton */}
                <div className="patient-medical-diagnosis-section">
                    <div className="patient-medical-diagnosis-header">
                        <SkeletonBase 
                            variant="rounded" 
                            width="36px" 
                            height="36px" 
                            style={{ borderRadius: '8px' }}
                        />
                        <SkeletonBase 
                            variant="text" 
                            width="250px" 
                            height="18px" 
                        />
                    </div>
                    <div className="patient-medical-diagnosis-content">
                        <SkeletonBase 
                            variant="text" 
                            width="100%" 
                            height="16px" 
                            style={{ marginBottom: '10px' }}
                        />
                        <SkeletonBase 
                            variant="text" 
                            width="98%" 
                            height="16px" 
                            style={{ marginBottom: '10px' }}
                        />
                        <SkeletonBase 
                            variant="text" 
                            width="95%" 
                            height="16px" 
                            style={{ marginBottom: '10px' }}
                        />
                        <SkeletonBase 
                            variant="text" 
                            width="90%" 
                            height="16px" 
                        />
                    </div>
                </div>

                {/* Biometric Info Skeleton */}
                <div className="patient-biometric-info-section">
                    <div className="patient-biometric-info-header">
                        <SkeletonBase 
                            variant="rounded" 
                            width="36px" 
                            height="36px" 
                            style={{ borderRadius: '8px' }}
                        />
                        <SkeletonBase 
                            variant="text" 
                            width="280px" 
                            height="18px" 
                        />
                    </div>
                    <div className="patient-biometric-info-grid">
                        {[1, 2, 3, 4, 5, 6, 7, 8].map((index) => (
                            <div key={index} className="patient-biometric-info-item">
                                <SkeletonBase 
                                    variant="rounded" 
                                    width="32px" 
                                    height="32px" 
                                    style={{ borderRadius: '6px' }}
                                />
                                <div style={{ flex: 1 }}>
                                    <SkeletonBase 
                                        variant="text" 
                                        width="70px" 
                                        height="10px" 
                                        style={{ marginBottom: '6px' }}
                                    />
                                    <SkeletonBase 
                                        variant="text" 
                                        width="90px" 
                                        height="14px" 
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Medical Family History Skeleton */}
                <div className="patient-medical-family-history-section">
                    <div className="patient-medical-family-history-header">
                        <SkeletonBase 
                            variant="rounded" 
                            width="36px" 
                            height="36px" 
                            style={{ borderRadius: '8px' }}
                        />
                        <SkeletonBase 
                            variant="text" 
                            width="220px" 
                            height="16px" 
                        />
                    </div>
                    <div className="patient-medical-family-history-list">
                        {[1, 2, 3].map((index) => (
                            <SkeletonBase 
                                key={index}
                                variant="rounded" 
                                width="160px" 
                                height="36px" 
                                style={{ borderRadius: '20px' }}
                            />
                        ))}
                    </div>
                </div>

                {/* Patient Documents Skeleton */}
                <div className="patient-documents-section">
                    <div className="patient-documents-header">
                        <SkeletonBase 
                            variant="rounded" 
                            width="36px" 
                            height="36px" 
                            style={{ borderRadius: '8px' }}
                        />
                        <SkeletonBase 
                            variant="text" 
                            width="220px" 
                            height="18px" 
                        />
                    </div>
                    <div className="patient-documents-categories">
                        {[1, 2, 3].map((index) => (
                            <SkeletonBase 
                                key={index}
                                variant="rounded" 
                                width="140px" 
                                height="36px" 
                                style={{ borderRadius: '20px' }}
                            />
                        ))}
                    </div>
                    <div className="patient-documents-list">
                        {[1, 2].map((index) => (
                            <div key={index} className="patient-documents-item">
                                <div className="patient-documents-item-left">
                                    <SkeletonBase 
                                        variant="rounded" 
                                        width="36px" 
                                        height="36px" 
                                        style={{ borderRadius: '6px' }}
                                    />
                                    <SkeletonBase 
                                        variant="text" 
                                        width="200px" 
                                        height="16px" 
                                    />
                                </div>
                                <div className="patient-documents-item-actions">
                                    <SkeletonBase 
                                        variant="rounded" 
                                        width="36px" 
                                        height="36px" 
                                        style={{ borderRadius: '6px' }}
                                    />
                                    <SkeletonBase 
                                        variant="rounded" 
                                        width="36px" 
                                        height="36px" 
                                        style={{ borderRadius: '6px' }}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PatientRequestDetailsSkeleton;

